<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div class="ui grid" v-else>
    <div class="three wide column">
      <div class="ui secondary vertical pointing menu" style="width: 100%">
        <a class="item" :class="{ active: currentTab === tabs.first }"
              @click="currentTab = tabs.first">
          Current shift
        </a>
        <a class="item" :class="{ active: currentTab === tabs.second }"
              @click="currentTab = tabs.second">
          Shifts 
        </a>
      </div>
    </div>
    <div class="thirteen wide column">
      <h3 class="ui dividing header" style="margin-bottom: 20px">
        {{ currentTab }}
      </h3> 
      <currentShift 
        v-if="currentTab === tabs.first"
        :currentShift="getCurrentShift()"
        :beforeCurrentShift="getBeforeCurrentShift()"
        :medicalMachines="medicalMachines"
        @shift-started="shiftStartEventListenner"
        @shift-ended="shiftEndedEventListenner"
        :roomId="roomId" 
      />

      <shifts 
        :shifts="shifts"
        v-if="currentTab === tabs.second" 
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    currentShift: require('./shifts_component/CurrentShift').default,
    shifts: require('./shifts_component/Shifts').default
  },
  props: {
    medicalMachines: { type: Array, required: true },
    roomId: { type: Number, required: true }
  },
  data() {
    return {
      shifts: [],
      tabs: {
        first: 'Current shift',
        second: 'Shifts'
      },
      currentTab: 'Current shift',
      loading: true
    }
  },
  mounted () {
    this.getShifts()
  },
  methods: {
    getCurrentShift() {
      const lastShift = this.shifts[0]
      return lastShift && lastShift.finished_at ? {} : lastShift
    },
    getBeforeCurrentShift () {
      const lastShift = this.shifts[0]
      let beforeLastShift = {};
      if (lastShift && lastShift.finished_at) {
        beforeLastShift = lastShift
      } else if (this.shifts.length > 1) {
        beforeLastShift = this.shifts[1]
      }

      return beforeLastShift
    },
    shiftStartEventListenner() {
      this.currentTab = this.tabs.second
      this.getShifts()
      this.$emit('current-shift-started')
    },
    shiftEndedEventListenner() {
      this.currentTab = this.tabs.second
      this.getShifts()
      this.$emit('current-shift-ended')
    },
    getShifts() {
      this.loading = true
      this.$http.get(`rooms/${this.roomId}/shifts`, {
        params: {
          clinic_id: this.getClinicId()
        }
      }).then(response => {
        this.shifts = response.data
        this.loading = false
      });
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/Shift.vue